export default __webpack_public_path__ + "static/media/buster_klein_25.60afb064.jpg";